/* eslint-disable no-restricted-imports */
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { BusinessModel } from '../../../data-layer/business/types';
import { UserModel } from '../../../data-layer/user/types';
import { ImportFormat } from '../../../types';
import { isBloggerBusiness, isBusinessAdmin } from '../../../utils/accessService';
import { useIsMobile } from '../../../utils/getIsMobile';
import { useTranslation } from '../../../utils/useTranslation';
import { Button } from '../../input/Button';
import { Box } from '../../layout/Box';
import { Typography } from '../../typography/Typography';
import { Title, Wrapper } from './styles';

export const BusinessPostStub = ({
    business,
    currentUser,
}: {
    business?: BusinessModel;
    currentUser?: UserModel;
}) => {
    const t = useTranslation();
    const navigate = useNavigate();

    const onCreatePost = useCallback(() => {
        navigate('/posts/create');
    }, [navigate]);

    const isBlogger = isBloggerBusiness(business?.type);
    const hasActiveInstagram =
        business?.instagram?.importFormat &&
        business.instagram.importFormat !== ImportFormat.DO_NOT_IMPORT;

    const isOwner = isBusinessAdmin(business?.id, currentUser);

    const isMobile = useIsMobile();
    const isWideProfile = !isMobile;

    if (!isOwner) {
        return (
            <Wrapper
                mr={isWideProfile ? 2 : undefined}
                borderRadius={isWideProfile ? 3 : undefined}
                background={isWideProfile ? 'none' : undefined}
            >
                <Title>{t(`У ${isBlogger ? 'автора' : 'бизнеса'} пока нет контента`)}</Title>
            </Wrapper>
        );
    }

    if (isBlogger) {
        if (hasActiveInstagram) {
            return (
                <Wrapper
                    mr={isWideProfile ? 2 : undefined}
                    borderRadius={isWideProfile ? 3 : undefined}
                    background={isWideProfile ? 'none' : undefined}
                >
                    <Title>{t('Здесь будут ваши посты')}</Title>
                    <Typography variant="body" textAlign="center">
                        {t(
                            'Посты можно создать самостоятельно или подождать загрузки из Instagram*.',
                        )}
                    </Typography>
                    <Typography mb={1} variant="body" textAlign="center">
                        {t(
                            'Обычно, загрузка занимает до суток, чтобы пост стал доступен другим пользователям необходимо добавить подходящий товар и пройти модерацию.',
                        )}
                    </Typography>
                    <Typography variant="caption" color="secondary" textAlign="center">
                        {t(
                            '*Meta, владеющая Instagram, признана экстремистской организацией на территории РФ',
                        )}
                    </Typography>
                </Wrapper>
            );
        }

        return (
            <Wrapper
                mr={isWideProfile ? 2 : undefined}
                borderRadius={isWideProfile ? 3 : undefined}
                background={isWideProfile ? 'none' : undefined}
            >
                <Title>{t('Здесь будут ваши посты')}</Title>
                <Typography variant="body" color="secondary" textAlign="center">
                    {t(
                        'Создайте пост и он появится здесь. Чтобы пост стал доступен другим пользователям необходимо пройти модерацию',
                    )}
                </Typography>
                <Box pt={3}>
                    <Button onClick={onCreatePost} size="m">
                        {t('Создать пост')}
                    </Button>
                </Box>
            </Wrapper>
        );
    }

    if (hasActiveInstagram) {
        return (
            <Wrapper
                mr={isWideProfile ? 2 : undefined}
                borderRadius={isWideProfile ? 3 : undefined}
                background={isWideProfile ? 'none' : undefined}
            >
                <Title>{t('Здесь будут ваши посты')}</Title>
                <Typography variant="body" textAlign="center">
                    {t('Посты можно создать самостоятельно или подождать загрузки из Instagram*.')}
                </Typography>
                <Typography mb={1} variant="body" textAlign="center">
                    {t(
                        'Обычно, загрузка занимает до суток, чтобы пост стал доступен другим пользователям необходимо пройти модерацию.',
                    )}
                </Typography>
                <Typography variant="caption" color="secondary" textAlign="center">
                    {t(
                        '*Meta, владеющая Instagram, признана экстремистской организацией на территории РФ',
                    )}
                </Typography>
            </Wrapper>
        );
    }

    return (
        <Wrapper
            mr={isWideProfile ? 2 : undefined}
            borderRadius={isWideProfile ? 3 : undefined}
            background={isWideProfile ? 'none' : undefined}
        >
            <Title>{t('Здесь будут ваши посты')}</Title>
            <Typography variant="body" color="secondary" textAlign="center">
                {t(
                    'Создайте пост и он появится здесь. Чтобы пост стал доступен другим пользователям необходимо пройти модерацию',
                )}
            </Typography>
            <Box pt={3}>
                <Button onClick={onCreatePost} size="m">
                    {t('Создать пост')}
                </Button>
            </Box>
        </Wrapper>
    );
};
